import packageJson from '../package.json';

export const NUXT_PUBLIC_BASE_URL_API = process.env.NUXT_PUBLIC_BASE_URL_API;

export const NUXT_PUBLIC_BE_URL = process.env.NUXT_PUBLIC_BE_URL;

export const SENTRY_ENV = process.env.NUXT_PUBLIC_SENTRY_ENV ?? 'development';
export const SENTRY_RELEASE = packageJson.version ?? 'unknown';
export const SENTRY_DISABLED = process.env.NUXT_PUBLIC_SENTRY_DISABLED ?? 'false';

export const STRIPE_ENTERPRISE_PLAN = process.env.NUXT_PUBLIC_STRIPE_ENTERPRISE_PLAN;
export const STRIPE_PROFESSIONAL_PLAN = process.env.NUXT_PUBLIC_STRIPE_PROFESSIONAL_PLAN;
export const STRIPE_PRICING_TABLE = process.env.NUXT_PUBLIC_STRIPE_PRICING_TABLE;
export const STRIPE_PRICING_TABLE_PROFESSIONAL = process.env.NUXT_PUBLIC_STRIPE_PRICING_TABLE_PROFESSIONAL;
export const STRIPE_PRICING_TABLE_ENTERPRISE = process.env.NUXT_PUBLIC_STRIPE_PRICING_TABLE_ENTERPRISE;
export const STRIPE_PUBLIC_KEY = process.env.NUXT_PUBLIC_STRIPE_PUBLIC_KEY;
